// Add user refs here to enable debug logging for specific users
export const DEBUG_USER_REFS = ["AAAAAAABqY8="];

export const shouldLogForUser = (userRef: string | undefined): boolean => {
  if (!userRef) return false;
  return DEBUG_USER_REFS.includes(userRef);
};
